import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { BaseModalComponent } from 'src/app/core/base-modal.componant';
import { SessionService } from 'src/app/shared/services/session.service';
import { LeagueService } from 'src/app/simulator-booking/services/league.service';
import { League } from 'src/app/simulator-booking/models/league';
import { provideNativeDateAdapter } from '@angular/material/core';

@Component({
    selector: 'edit-league-modal',
    templateUrl: './edit-league-modal.component.html',
    styleUrl: './edit-league-modal.component.scss',
    providers: [provideNativeDateAdapter()],
    standalone: false
})
export class EditLeagueModalComponent extends BaseModalComponent implements OnInit {

    public league: League;
    public form = new FormGroup({
        id: new FormControl('', {
            validators: Validators.required
        }),
        name: new FormControl('', {
            validators: Validators.required
        }),
        description: new FormControl('')
    });

    constructor(
        private sessionService: SessionService,
        private leagueService: LeagueService,
        public dialogRef: MatDialogRef<EditLeagueModalComponent>
    ) {
        super();
    }

    ngOnInit(): void {
        if (this.league) {
            this.form.patchValue({
                id: this.league.id,
                name: this.league.name,
                description: this.league.description
            });
        }
    }

    submit({ value, valid }): void {
        if (valid) {
            this.isLoading = true;
            const data = {
                ...value,
                organizationId: this.league.organizationId,
                lastEditedBy: this.sessionService.getUserId()
            };

            this.leagueService.update(this.league.id, data).subscribe({
                next: (result) => {
                    if (result !== null && result !== undefined) {
                        this.dialogRef.close("save");
                    }
                },
                error: (error) => {
                    console.error(error);
                    this.setError(error, this.form);
                    this.isLoading = false;
                },
                complete: () => this.isLoading = false
            });
        }
    }
}

